/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-23 14:20:03
 * @LastEditors: liuziwei
 * @Description: 券浮层 - 券 item 组件
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="coupon-item-container">
    <!-- 信息展示部分 -->
    <view class="coupon-info-area">
      <!-- 券优惠信息 -->
      <view class="left-area">
        <view class="discount-area">
          <text class="discount">{{ couponInfo.price }}</text>
          <text class="left-text">{{ couponInfo.priceUnit }}</text>
        </view>
        <text wx:if="{{couponInfo.priceTip}}" class="confine-text">
          {{ couponInfo.priceTip }}
        </text>
      </view>
      <!-- 券详情介绍 -->
      <view class="right-area">
        <!-- 券名称 -->
        <text wx:if="{{couponInfo.name}}" class="name">{{ couponInfo.name }}</text>
        <text class="expire-time-text">{{ couponInfo.expiredTimeText }}{{ couponInfo.remark }}</text>
      </view>
    </view>
    <!-- 券状态部分 -->
    <!-- <view
      class="coupon-status-area coupon-status-area-cyber"
      style="{{statusColor}}"
      bindtap="tapActivity"
      wx:if="{{couponInfo.txt}}"
    >
      <view class="arrow">{{ couponInfo.txt }}</view>
    </view> -->
    <view class="coupon-status-area" style="{{couponStatusInfo.text_color}}" bindtap="tapCoupon" >
      <text wx:if="{{isUnlock}}" class="lockIcon"></text>
      {{ couponStatusInfo.text }}
    </view>
  </view>
</template>

<script>
  import { createComponent,mpx } from '@didi/es-mpx-creator'
  // import { couponStatusConf } from '@/config/coupon'
  import { goTo } from '@didi/webx-js'
  import { isWXMini, isALIMini } from '@/common/constant'
  import { debounce } from '@/utils'
  import dayjs from 'dayjs'

  createComponent({
    props: {
      couponData: {
        type: Object,
        value: () => {}
      },
      //是否是未解锁
      isUnlock: {
        type: Boolean,
        value: false
      },
      //是否未领取
      isUnclaimed: {
        type: Boolean,
        value: false
      },
      //是否已领取
      isReceived: {
        type: Boolean,
        value: false
      },
    },
    computed: {
      couponInfo() {
        let { name, amount, discount, maxAmount, remark, batchType, expiredTime } = this.couponData
        batchType = Number(batchType)
        return {
          name,
          expiredTimeText: expiredTime ? `有效期至${dayjs(expiredTime).format('YYYY-MM-DD')}` : '',
          remark,
          price: batchType === 100 ? discount : amount / 100,
          priceUnit: batchType === 100 ? '折' : '元',
          priceTip: maxAmount,
        }
      },
      //卷状态信息
      couponStatusInfo(){
        if(this.isUnlock){
          return {
            text: '待解锁',
            text_color:{
              color: '#F86316',
              opacity: 1
            }
          }
        }else if(this.isUnclaimed){
          return {
            text: '立即领取',
            text_color:{
              color: '#F86316',
              opacity: 1
            }
          }
        }else if(this.isReceived){
          return {
            text: '已领取',
            text_color:{
              color: '#F86316',
              opacity: 0.3
            }
          }
        }
      },


      isMiniH5() {
        return isWXMini || isALIMini
      }
    },
    methods: {
      // 点击领券
      tapCoupon() {
        if (this.isUnlock) {
          this.unlockTap()
          return
        }
        if (this.isReceived) {
          return
        }
        // 上报事件
        this.triggerEvent('receiveSingleCoupon', {
          coupon: this.couponData,
          receiveUrl: this.couponData?.receive_url ?? ''
        })
      },
      //待解锁点击提示 成功支付一笔机票订单解锁
      unlockTap(){
         mpx.showToast({
            mask: true,
            title: '成功支付一笔机票订单解锁',
            icon: 'none',
        })
      },
      // 点击跳转活动页
      // tapActivity: debounce(
      //   function () {
      //     // const url = this.isMiniH5 ? this.couponInfo.toUrlMiniH5 : this.couponInfo.toUrl
      //     goTo({
      //       url: this.couponInfo.toUrl
      //     })
      //     // if(this.isMiniH5) {
      //     //   goTo({
      //     //     path: this.couponInfo.toUrlMiniH5
      //     //   })
      //     // } else {
      //     //   goTo({
      //     //     url: this.couponInfo.toUrl
      //     //   })
      //     // }
      //   },
      //   500,
      //   true
      // )
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-item-container
    position relative
    border-radius 10px
    background #FFF6F1
    height 82px
    display flex
    align-items center
    justify-content space-between
    margin-bottom 10px
    // 替换成 drop-shadow
    -webkit-mask radial-gradient(circle at calc(100% - 94px) 5px, transparent 5px, #000 0) 0px -5px
    mask radial-gradient(circle at calc(100% - 94px) 5px, transparent 5px, #000 0) 0px -5px
    &:last-child
      margin-bottom 0
    .coupon-info-area
      height 100%
      display flex
      align-items center
      justify-content center
      .left-area
        width 90px
        display flex
        flex-shrink 0
        flex-direction column
        align-items center
        .discount-area
          display flex
          align-items baseline
          justify-content center
          .discount, .unit
            font-weight 400
            color #F86316
          .discount
            font-family Barlow Semi Condensed
            font-size 35px
            line-height 35px
          .maxAmount
            font-family PingFang SC
            font-size 14px
            line-height 15px
          .left-text
            font-family PingFang SC
            font-size 11px
            font-weight 400
            line-height 11px
            color #FF5900
            margin-left 2px
        .confine-text
          font-family PingFang SC
          font-size 10px
          font-weight normal
          line-height 10px
          color #B69786
          margin-top 5px
      .right-area
        display flex
        flex-direction column
        .name
          font-family PingFang SC
          font-size 15px
          font-weight 600
          line-height 15px
          color #333
          margin-bottom 7px
        .expire-time-text, .discount
          font-family PingFang SC
          font-size 10px
          font-weight normal
          line-height 13px
          color #B69786
          padding-right 5px
        .expire-time-text
          margin-bottom 5px
    .coupon-status-area
      flex-shrink 0
      width 94px
      height 61px
      display flex
      align-items center
      justify-content center
      border-left 1px dashed rgba(248, 99, 22, 0.3)
      font-family PingFang SC
      font-size 15px
      font-weight 500
      line-height 15px
      color #F86316
      &-cyber
        font-size 14px
      .lockIcon
        display inline-block
        width 16px
        height 16px
        background-image url('https://dpubstatic.udache.com/static/dpubimg/5ortLTbddtPLQovuSjArt.png')
        background-size 100% 100%
        margin-right 2px
    .arrow
      position relative
      &::after
        content ''
        top 6px
        right -5px
        position absolute
        width 2px
        height 2px
        border-top 1.5px solid
        border-right 1.5px solid
        transform rotate(45deg)
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
